export default {
    title: 'Mon quiz sur la santé hormonale',
    score: [],
    text:'En parcourant ce questionnaire, cochez les symptômes qui vous concernent actuellement',
    language: 'FR / EN',
    icons: {
        title: 'mdi-checkbox-multiple-marked-outline',
        languages: 'mdi-earth',
    }
};
